module.exports = __webpack_public_path__ + "img/1.97dc660d.png";